function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function _callSuper(t, o, e) {
  return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e));
}
function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized(t);
}
function _assertThisInitialized(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}
function _isNativeReflectConstruct() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct = function _isNativeReflectConstruct() {
    return !!t;
  })();
}
function _superPropGet(t, o, e, r) {
  var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e);
  return 2 & r && "function" == typeof p ? function (t) {
    return p.apply(e, t);
  } : p;
}
function _get() {
  return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) {
    var p = _superPropBase(e, t);
    if (p) {
      var n = Object.getOwnPropertyDescriptor(p, t);
      return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value;
    }
  }, _get.apply(null, arguments);
}
function _superPropBase(t, o) {
  for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t)););
  return t;
}
function _getPrototypeOf(t) {
  return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf(t);
}
function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf(t, e);
}
function _setPrototypeOf(t, e) {
  return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf(t, e);
}
var saito = require('../../lib/saito/saito');
var ModTemplate = require('../../lib/templates/modtemplate');
var CallLauncher = require('./lib/components/call-launch');
var CallInterfaceVideo = require('./lib/components/call-interface-video');
var CallInterfaceFloat = require('./lib/components/call-interface-float');
var DialingInterface = require('./lib/components/dialer');
var SaitoOverlay = require('../../lib/saito/ui/saito-overlay/saito-overlay');
var StreamManager = require('./lib/StreamManager');
var AppSettings = require('./lib/stun-settings');
var CallDiagnostics = require('./lib/components/call-diagnostics');
var HomePage = require('./index');
var SaitoHeader = require('./../../lib/saito/ui/saito-header/saito-header');
var Videocall = /*#__PURE__*/function (_ModTemplate) {
  function Videocall(app) {
    var _this;
    _classCallCheck(this, Videocall);
    _this = _callSuper(this, Videocall, [app]);
    _this.app = app;
    _this.appname = 'Saito Talk';
    _this.name = 'Videocall';
    _this.slug = 'videocall';
    _this.description = 'P2P Video & Audio Connection Module';
    _this.categories = 'Utilities Communications';
    _this.status = 'prod';
    _this["class"] = 'app';
    _this.icon = 'fa-solid fa-mobile-screen-button';
    _this.request_no_interrupts = true; // Don't let chat popup inset into /videocall
    _this.isRelayConnected = false;

    //
    // short URLS
    //
    _this.shortlinks_enabled = 1;
    _this.screen_share = false;
    _this.styles = ['/videocall/style.css'];
    _this.stun = null; //The stun API
    _this.streams = null;
    _this.diagnostics = new CallDiagnostics(app, _this);
    _this.dialer = new DialingInterface(app, _this);
    _this.layout = 'focus';
    _this.have_joined_room = 0;
    _this.social = _this.buildSocial({
      twitter: '@SaitoOfficial',
      title: '🟥 Saito Talk',
      url: '/videocall/',
      description: 'Peer to peer voice and video calling with no middleman',
      image: '/videocall/img/video-call-og.png'
    });

    //When CallLauncher is rendered or game-menu triggers it
    app.connection.on('stun-init-call-interface', function (settings) {
      if (_this.CallInterface) {
        console.warn('TALK: Already instatiated a video/audio call manager');
        return;
      }
      if (!_this.streams) {
        console.debug('TALK: Instantiate StreamManager');
        _this.streams = new StreamManager(_this.app, _this, settings);
      } else {
        _this.streams.parseSettings(settings);
        _this.streams.active = true;
      }
      console.debug('TALK [stun-init-call-interface]: UI settings ', settings);
      if (settings.ui === 'large') {
        _this.CallInterface = new CallInterfaceVideo(app, _this, true);
      } else if (settings.ui === 'video') {
        _this.CallInterface = new CallInterfaceVideo(app, _this, false);
      } else {
        _this.CallInterface = new CallInterfaceFloat(app, _this);
      }
      _this.saveCallToKeychain();
    });
    app.connection.on('reset-stun', function () {
      console.log('Reset Stun');
      _this.room_obj = null;
      if (_this.CallInterface) {
        _this.CallInterface.destroy();
        _this.CallInterface = null;
      }
      _this.streams = null;
      _this.have_joined_room = 0;
      _this.app.storage.saveOptions();
    });
    app.connection.on('stun-connection-close', function (peerId) {
      var _this2;
      if ((_this2 = _this) !== null && _this2 !== void 0 && (_this2 = _this2.streams) !== null && _this2 !== void 0 && _this2.active) {
        _this.disconnect(peerId, ' has no connection');
        salert('STUN connection failure. Try refreshing and reconnecting');
      }
    });
    return _this;
  }

  /**
   * rendered on:
   *  - /videocall
   *  - Saito-header menu
   *  - Saito-user-menu
   *  - game-menu options
   *
   */
  _inherits(Videocall, _ModTemplate);
  return _createClass(Videocall, [{
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(app) {
        var _this$app$options, _this$app$options$stu, _this$app$options$stu2;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return _superPropGet(Videocall, "initialize", this, 3)([app]);
            case 1:
              if (app.BROWSER) {
                if (!((_this$app$options = this.app.options) !== null && _this$app$options !== void 0 && (_this$app$options = _this$app$options.stun) !== null && _this$app$options !== void 0 && _this$app$options.settings)) {
                  this.app.options.stun = {
                    settings: {
                      privacy: 'all'
                    }
                  };
                }
                if ((_this$app$options$stu = this.app.options.stun.settings) !== null && _this$app$options$stu !== void 0 && _this$app$options$stu.layout) {
                  this.layout = (_this$app$options$stu2 = this.app.options.stun.settings) === null || _this$app$options$stu2 === void 0 ? void 0 : _this$app$options$stu2.layout;
                }
                if (app.browser.returnURLParameter('stun_video_chat')) {
                  this.room_obj = JSON.parse(app.crypto.base64ToString(app.browser.returnURLParameter('stun_video_chat')));

                  // JOIN THE ROOM
                  if (!this.browser_active) {
                    this.renderInto('.saito-overlay');
                  }
                }
                try {
                  this.stun = app.modules.returnFirstRespondTo('peer-manager');
                } catch (err) {
                  console.error('SaitoTalk: Videocall unavailable without Stun module installed!');
                }
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function initialize(_x) {
        return _initialize.apply(this, arguments);
      }
      return initialize;
    }()
  }, {
    key: "onPeerServiceUp",
    value: function () {
      var _onPeerServiceUp = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(app, peer, service) {
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              if (!(app.BROWSER !== 1)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              if (service.service === 'relay') {
                this.isRelayConnected = true;
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function onPeerServiceUp(_x2, _x3, _x4) {
        return _onPeerServiceUp.apply(this, arguments);
      }
      return onPeerServiceUp;
    }()
  }, {
    key: "render",
    value: function () {
      var _render = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!this.browser_active) {
                _context3.n = 3;
                break;
              }
              this.header = new SaitoHeader(this.app, this);
              _context3.n = 1;
              return this.header.initialize(this.app);
            case 1:
              this.addComponent(this.header);
              this.addComponent(new CallLauncher(this.app, this, 'body'));
              _context3.n = 2;
              return _superPropGet(Videocall, "render", this, 3)([]);
            case 2:
              this.app.connection.emit('videocall-opened');
            case 3:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function render() {
        return _render.apply(this, arguments);
      }
      return render;
    }()
  }, {
    key: "renderInto",
    value: function () {
      var _renderInto = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(qs) {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              if (qs == '.saito-overlay') {
                if (!this.renderIntos[qs]) {
                  this.renderIntos[qs] = [];
                  this.renderIntos[qs].push(new CallLauncher(this.app, this, qs));
                }
                this.attachStyleSheets();
                this.renderIntos[qs].forEach(function (comp) {
                  comp.render();
                });
                this.app.connection.emit('videocall-opened');
              }
            case 1:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function renderInto(_x5) {
        return _renderInto.apply(this, arguments);
      }
      return renderInto;
    }()
  }, {
    key: "respondTo",
    value: function respondTo(type, obj) {
      var _this3 = this;
      var call_self = this;
      var app = this.app;
      if (type === 'user-menu') {
        var _this$streams;
        //Don't provide a calling hook if in the video call app!
        // if (call_self.browser_active) {
        // 	return null;
        // }
        if ((obj === null || obj === void 0 ? void 0 : obj.publicKey) !== this.publicKey && ((_this$streams = this.streams) === null || _this$streams === void 0 ? void 0 : _this$streams.active) === true) {
          return [{
            text: 'Kick User From Call',
            icon: 'fa-solid fa-user-slash',
            callback: function () {
              var _callback = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(app, public_key) {
                return _regenerator().w(function (_context5) {
                  while (1) switch (_context5.n) {
                    case 0:
                      console.info('TALK: kicking user: ', public_key);
                      app.connection.emit('remove-peer-box', public_key);
                      _context5.n = 1;
                      return _this3.sendKickTransaction(public_key);
                    case 1:
                      _this3.streams.removePeer(public_key, 'was kicked out');
                    case 2:
                      return _context5.a(2);
                  }
                }, _callee5);
              }));
              function callback(_x6, _x7) {
                return _callback.apply(this, arguments);
              }
              return callback;
            }()
          }];
        } else {
          if ((obj === null || obj === void 0 ? void 0 : obj.publicKey) !== this.publicKey) {
            this.attachStyleSheets();
            return [{
              text: 'Video/Audio Call',
              icon: 'fas fa-video',
              callback: function callback(app, public_key) {
                if (call_self !== null && call_self !== void 0 && call_self.room_obj) {
                  salert('Already in or establishing a call');
                  console.debug('SaitoTalk: ', call_self.room_obj);
                } else {
                  call_self.dialer.establishStunCallWithPeers([public_key]);
                }
              }
            }];
          }
        }
      }
      if (type === 'saito-header') {
        var _this$app$modules$ret;
        if (!this.browser_active && !((_this$app$modules$ret = this.app.modules.returnActiveModule()) !== null && _this$app$modules$ret !== void 0 && _this$app$modules$ret.disable_talk)) {
          this.attachStyleSheets();
          return [{
            text: 'Saito Talk',
            icon: this.icon,
            type: 'quicklaunch',
            callback: function callback(app, id) {
              call_self.renderInto('.saito-overlay');
            },
            navigation: '/videocall'
          }];
        }
      }

      //
      //Game-Menu passes the game_mod as the obj, so we can test if we even want to add the option
      //
      if (type == 'game-menu') {
        var _obj$game;
        this.attachStyleSheets();

        //Set listeners for stun events
        this.app.connection.on('show-call-interface', function () {
          document.getElementById('start-group-video-chat').classList.add('disable-menu');
        });
        this.app.connection.on('reset-stun', function () {
          document.getElementById('start-group-video-chat').classList.remove('disable-menu');
          document.getElementById('start-group-video-chat').innerHTML = 'Start Call';
        });
        this.app.connection.on('stun-receive-ingame-call', function (room_obj) {
          _this3.room_obj = room_obj;
          _this3.dialer.render('', false);
        });
        if ((obj === null || obj === void 0 || (_obj$game = obj.game) === null || _obj$game === void 0 || (_obj$game = _obj$game.players) === null || _obj$game === void 0 ? void 0 : _obj$game.length) > 1) {
          var menu_items = {
            id: 'game-social',
            text: 'Chat',
            submenus: [{
              parent: 'game-social',
              text: 'Start Call',
              id: 'start-group-video-chat',
              "class": 'start-group-video-chat',
              callback: function callback(app, game_mod) {
                if (!(call_self !== null && call_self !== void 0 && call_self.added_game_listener)) {
                  app.connection.on('start-game-call', function () {
                    game_mod.sendMetaMessage('CALL', call_self.room_obj);
                    app.connection.emit('stun-init-call-interface', {
                      ui: call_self.room_obj.ui,
                      audio: true,
                      video: call_self.room_obj.ui == 'video'
                    });
                    app.connection.emit('start-stun-call');
                  });
                  call_self.added_game_listener = true;
                }

                //Start Call
                game_mod.menu.hideSubMenus();
                if (game_mod !== null && game_mod !== void 0 && game_mod.room_obj && !call_self.room_obj) {
                  call_self.room_obj = Object.assign({}, game_mod.room_obj);
                }
                if (call_self !== null && call_self !== void 0 && call_self.room_obj) {
                  var _call_self$streams;
                  if ((_call_self$streams = call_self.streams) !== null && _call_self$streams !== void 0 && _call_self$streams.active) {
                    salert('Already in or establishing a call');
                    console.debug('SaitoTalk: ', call_self.room_obj);
                  } else {
                    app.connection.emit('stun-init-call-interface', {
                      ui: call_self.room_obj.ui,
                      audio: true,
                      video: call_self.room_obj.ui == 'video'
                    });
                    app.connection.emit('start-stun-call');
                  }
                } else {
                  call_self.dialer.establishStunCallWithPeers(/*[...game_mod.game.players]*/);
                }
              }
            }]
          };
          return menu_items;
        }
      }
      if (type === 'saito-link') {
        var urlParams = new URL(obj === null || obj === void 0 ? void 0 : obj.link).searchParams;
        var entries = urlParams.entries();
        var _iterator = _createForOfIteratorHelper(entries),
          _step;
        try {
          var _loop = function _loop() {
              var pair = _step.value;
              if (pair[0] == 'stun_video_chat') {
                return {
                  v: {
                    processLink: function processLink(link) {
                      _this3.room_obj = JSON.parse(_this3.app.crypto.base64ToString(pair[1]));
                      _this3.renderInto('.saito-overlay');
                    }
                  }
                };
              }
            },
            _ret;
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            _ret = _loop();
            if (_ret) return _ret.v;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      if (type === 'chat-actions') {
        if (obj !== null && obj !== void 0 && obj.publicKey) {
          if (obj.publicKey !== this.publicKey) {
            this.attachStyleSheets();
            return [{
              text: 'Video/Audio Call',
              icon: 'fas fa-phone',
              callback: function callback(app, id) {
                if (call_self !== null && call_self !== void 0 && call_self.room_obj) {
                  salert('Already in or establishing a call');
                  console.debug('SaitoTalk: ', call_self.room_obj);
                } else {
                  call_self.dialer.establishStunCallWithPeers([obj.publicKey]);
                }
              }
            }];
          }
        }
      }
      if (type === 'call-actions') {
        return [{
          text: 'Present',
          icon: 'fa-solid fa-display',
          hook: 'screen_share onair',
          prepend: true,
          callback: function callback(app) {
            //
            // screen_share === true when we present; a public key when a peer does
            //
            if (call_self.screen_share && call_self.screen_share !== true) {
              siteMessage("".concat(call_self.app.keychain.returnUsername(call_self.screen_share), " is presenting"), 2000);
              return;
            }
            if (call_self.screen_share) {
              call_self.app.connection.emit('stop-share-screen');
            } else {
              call_self.app.connection.emit('begin-share-screen');
            }
          },
          event: function event(id) {
            call_self.app.connection.on('toggle-screen-share-label', function () {
              var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
              var sender = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
              var container = document.getElementById(id);
              if (!container) {
                return;
              }
              var label = container.querySelector('label');
              var icon = container.querySelector('i');
              if (state) {
                container.classList.add('recording');
                icon === null || icon === void 0 || icon.classList.add('recording');
                if (sender && sender !== call_self.publicKey) {
                  container.classList.add('not-clickable');
                  container.title = "".concat(call_self.app.keychain.returnUsername(sender), " is presenting");
                  if (label) label.innerText = 'Presenting';
                } else {
                  container.title = 'Stop presenting';
                  if (label) label.innerText = 'Stop';
                }
              } else {
                container.classList.remove('recording', 'not-clickable');
                icon === null || icon === void 0 || icon.classList.remove('recording');
                container.title = 'Present your screen';
                if (label) label.innerText = 'Present';
              }
            });
          }
        }, {
          text: 'Settings',
          icon: 'fa-solid fa-cog',
          prepend: true,
          callback: function callback(app) {
            app.connection.emit('videocall-show-settings');
          }
        }];
      }
      if (type === 'media-request') {
        var _this$streams2;
        if (this !== null && this !== void 0 && (_this$streams2 = this.streams) !== null && _this$streams2 !== void 0 && _this$streams2.active) {
          return {
            localStream: this.streams.localStream,
            remoteStreams: this.streams.remoteStreams
          };
        } else {
          return null;
        }
      }
      return _superPropGet(Videocall, "respondTo", this, 3)([type, obj]);
    }
  }, {
    key: "hasSettings",
    value: function hasSettings() {
      return true;
    }
  }, {
    key: "loadSettings",
    value: function loadSettings() {
      var container = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var as = new AppSettings(this.app, this, container);
      as.render();
    }
  }, {
    key: "onConfirmation",
    value: function onConfirmation(blk, tx, conf) {
      if (tx == null) {
        return;
      }
      var message = tx.returnMessage();
      if (Number(conf) == 0) {
        if (message.module === 'Videocall') {
          if (this.app.BROWSER === 1) {
            var from = tx.from[0].publicKey;
            if (this.hasSeenTransaction(tx, blk)) return;
            if (!this.have_joined_room || tx.timestamp + 3000 < this.have_joined_room) {
              console.log('STUN/TX Ignore (on chain) txs from before I joined the call', new Date(tx.timestamp).toTimeString(), new Date(this.have_joined_room).toTimeString());
              return;
            }
            if (!tx.isFrom(this.publicKey)) {
              //Someone joined call room
              if (message.request === 'call-list-request') {
                console.info('TALK: [callListRequest -- onConfirmation] from ', from);
                this.receiveCallListRequestTransaction(this.app, tx);
              }
              //Someone in the room responds
              if (message.request === 'call-list-response') {
                console.info('TALK: [callListResponse -- onConfirmation] from ', from);
                this.receiveCallListResponseTransaction(this.app, tx);
              }
            }
          }
        }
      }
    }
  }, {
    key: "handlePeerTransaction",
    value: function () {
      var _handlePeerTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(app) {
        var tx,
          peer,
          mycallback,
          txmsg,
          _txmsg$request,
          _this$room_obj,
          _this$streams3,
          _txmsg$data,
          from,
          _this$diagnostics,
          _from,
          _this$app$options$stu3,
          _args6 = arguments;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.n) {
            case 0:
              tx = _args6.length > 1 && _args6[1] !== undefined ? _args6[1] : null;
              peer = _args6.length > 2 ? _args6[2] : undefined;
              mycallback = _args6.length > 3 ? _args6[3] : undefined;
              if (!(tx == null)) {
                _context6.n = 1;
                break;
              }
              return _context6.a(2);
            case 1:
              txmsg = tx.returnMessage();
              if (!(this.app.BROWSER === 1)) {
                _context6.n = 9;
                break;
              }
              if (!(tx.isTo(this.publicKey) && !tx.isFrom(this.publicKey))) {
                _context6.n = 9;
                break;
              }
              if (!((_txmsg$request = txmsg.request) !== null && _txmsg$request !== void 0 && _txmsg$request.includes('stun-connection'))) {
                _context6.n = 2;
                break;
              }
              console.debug('TALK [HPT]: Stun-connection', txmsg.data);
              this.dialer.receiveStunCallMessageFromPeers(tx);
              return _context6.a(2);
            case 2:
              if (!(txmsg.module == 'Videocall' || txmsg.module == 'Stun')) {
                _context6.n = 9;
                break;
              }
              if (!(!this.have_joined_room || tx.timestamp + 3000 < this.have_joined_room)) {
                _context6.n = 3;
                break;
              }
              console.log('STUN/TX Ignore (HPT) txs from before I joined the call (will wait for onchain...)', new Date(tx.timestamp).toTimeString(), new Date(this.have_joined_room).toTimeString());
              console.log(txmsg);
              return _context6.a(2);
            case 3:
              if (!this.hasSeenTransaction(tx)) {
                _context6.n = 4;
                break;
              }
              return _context6.a(2);
            case 4:
              // Allow processing from outside of room
              //
              from = tx.from[0].publicKey;
              if (!(txmsg.request === 'call-list-request')) {
                _context6.n = 5;
                break;
              }
              console.info('TALK: [callListRequest -- handlePeerTransaction] from ', from);
              this.receiveCallListRequestTransaction(this.app, tx);
              return _context6.a(2);
            case 5:
              if (!(!(this !== null && this !== void 0 && (_this$room_obj = this.room_obj) !== null && _this$room_obj !== void 0 && _this$room_obj.call_id) || this.room_obj.call_id !== txmsg.call_id /*|| !this.streams*/)) {
                _context6.n = 6;
                break;
              }
              return _context6.a(2);
            case 6:
              if (txmsg.request !== 'call-list-response') {
                (_this$diagnostics = this.diagnostics) === null || _this$diagnostics === void 0 || _this$diagnostics.record(from, "Received: ".concat(txmsg.request));
              }
              console.debug('TALK [HPT]: ' + txmsg.request);
              if (!(txmsg.request === 'call-list-response')) {
                _context6.n = 7;
                break;
              }
              console.info('TALK: [callListResponse -- HPT] from ', from);
              this.receiveCallListResponseTransaction(this.app, tx);
              return _context6.a(2);
            case 7:
              if (!(txmsg.request === 'peer-joined')) {
                _context6.n = 8;
                break;
              }
              _from = tx.from[0].publicKey;
              console.debug('TALK [peer-joined]: ' + _from);
              //Check if we have a broken stun connection
              /*if (!this.stun.hasConnection(from, true)) {
              console.info('TALK [peer-joined]: reset stun peer connection for new join ', from);
              this.stun.removePeerConnection(from);
              }*/

              this.app.connection.emit('remove-waiting-video-box');
              this.app.connection.emit('add-remote-stream-request', _from, null);
              if (!this.room_obj.call_peers.includes(_from)) {
                this.room_obj.call_peers.push(_from);
                this.app.connection.emit('stun-update-link');
              }

              //Limbo Hook
              this.app.connection.emit('videocall-add-party', _from);
              this.stun.createPeerConnection(_from, false);
              return _context6.a(2);
            case 8:
              if (txmsg.request === 'peer-left') {
                if (!tx.isFrom(this.publicKey)) {
                  this.disconnect(tx.from[0].publicKey);
                }
              }
              if (txmsg.request === 'peer-kicked') {
                this.app.connection.emit('stun-disconnect');
                siteMessage("".concat(this.app.keychain.returnUsername(tx.from[0].publicKey), " kicked you out of the call"));
              }
              if (txmsg.request === 'peer-kick-broadcast') {
                this.disconnect(txmsg.kicked_peer, 'was kicked out of the call');
              }
              if (txmsg.request === 'toggle-audio' || txmsg.request == 'toggle-video') {
                this.app.connection.emit("peer-".concat(txmsg.request, "-status"), txmsg.data);
              }
              if (txmsg.request === 'toggle-transcription' && (_this$streams3 = this.streams) !== null && _this$streams3 !== void 0 && _this$streams3.active && this.room_obj.call_peers.includes(from) && typeof ((_txmsg$data = txmsg.data) === null || _txmsg$data === void 0 ? void 0 : _txmsg$data.enabled) === 'boolean') {
                this.streams.updateTranscriptionStatus(from, txmsg.data.enabled);
              }
              if (txmsg.request === 'screen-share-start') {
                if (this.screen_share !== tx.from[0].publicKey) {
                  this.screen_share = tx.from[0].publicKey;
                  this.app.connection.emit('add-remote-stream-request', 'presentation', null);
                  this.app.connection.emit('toggle-screen-share-label', true, tx.from[0].publicKey);
                  siteMessage("".concat(this.app.keychain.returnUsername(tx.from[0].publicKey), " started presenting"), 2500);
                }
              }
              if (txmsg.request === 'screen-share-stop') {
                this.app.connection.emit('remove-peer-box', 'presentation');
                this.app.connection.emit('stun-switch-view', ((_this$app$options$stu3 = this.app.options.stun.settings) === null || _this$app$options$stu3 === void 0 ? void 0 : _this$app$options$stu3.layout) || this.layout);
                this.streams.remoteStreams["delete"]('presentation');
                this.screen_share = null;
                this.app.connection.emit('toggle-screen-share-label', false);
              }

              // Peer sharing connection state with people in the call...
              if (txmsg.request === 'broadcast-call-list') {
                this.receiveBroadcastListTransaction(this.app, tx);
              }
            case 9:
              return _context6.a(2, _superPropGet(Videocall, "handlePeerTransaction", this, 3)([app, tx, peer, mycallback]));
          }
        }, _callee6, this);
      }));
      function handlePeerTransaction(_x8) {
        return _handlePeerTransaction.apply(this, arguments);
      }
      return handlePeerTransaction;
    }()
  }, {
    key: "disconnect",
    value: function disconnect(peer) {
      var _this4 = this;
      var msg = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'left the meeting';
      for (var i = 0; i < this.room_obj.call_peers.length; i++) {
        if (this.room_obj.call_peers[i] == peer) {
          this.room_obj.call_peers.splice(i, 1);
          setTimeout(function () {
            _this4.app.connection.emit('stun-update-link');
            //wait to update because peer might come right back
          }, 300000);
          break;
        }
      }
      this.app.connection.emit('remove-peer-box', peer);

      //Limbo Hook
      this.app.connection.emit('videocall-remove-party', peer);
      //See if we need to also hang up on our end
      this.streams.removePeer(peer, msg);
    }

    // A convenience function to send metadata through the stun channel (if established) or over relay otherwise
    // but
  }, {
    key: "sendOffChainMessage",
    value: function () {
      var _sendOffChainMessage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(request, data) {
        var newtx, _iterator2, _step2, peer;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.n) {
            case 0:
              _context7.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 1:
              newtx = _context7.v;
              _iterator2 = _createForOfIteratorHelper(this.room_obj.call_peers);
              try {
                for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                  peer = _step2.value;
                  if (peer != this.publicKey) {
                    newtx.addTo(peer);
                  }
                }
              } catch (err) {
                _iterator2.e(err);
              } finally {
                _iterator2.f();
              }
              newtx.msg = {
                module: 'Videocall',
                request: request,
                call_id: this.room_obj.call_id,
                data: data
              };
              _context7.n = 2;
              return newtx.sign();
            case 2:
              this.app.connection.emit('relay-transaction', newtx);
            case 3:
              return _context7.a(2);
          }
        }, _callee7, this);
      }));
      function sendOffChainMessage(_x9, _x0) {
        return _sendOffChainMessage.apply(this, arguments);
      }
      return sendOffChainMessage;
    }()
  }, {
    key: "sendCallEntryTransaction",
    value: function () {
      var _sendCallEntryTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8() {
        var _this$room_obj2, _this$diagnostics2, _event$profile;
        var newtx, event, _iterator3, _step3, participant;
        return _regenerator().w(function (_context8) {
          while (1) switch (_context8.n) {
            case 0:
              if (this.room_obj) {
                _context8.n = 1;
                break;
              }
              console.error('TALK: No room object');
              return _context8.a(2);
            case 1:
              _context8.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(this.room_obj.call_id);
            case 2:
              newtx = _context8.v;
              if ((_this$room_obj2 = this.room_obj) !== null && _this$room_obj2 !== void 0 && _this$room_obj2.host_public_key) {
                newtx.addTo(this.room_obj.host_public_key);
              }
              (_this$diagnostics2 = this.diagnostics) === null || _this$diagnostics2 === void 0 || _this$diagnostics2.record('local', 'Requesting participant list from room / host');

              // Fallback for saved calls when blocks aren't forming correctly
              event = this.app.keychain.returnKey(this.room_obj.call_id, true);
              if (event !== null && event !== void 0 && (_event$profile = event.profile) !== null && _event$profile !== void 0 && _event$profile.participants) {
                _iterator3 = _createForOfIteratorHelper(event.profile.participants);
                try {
                  for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                    participant = _step3.value;
                    newtx.addTo(participant);
                  }
                } catch (err) {
                  _iterator3.e(err);
                } finally {
                  _iterator3.f();
                }
              }
              newtx.msg.module = 'Videocall';
              newtx.msg.request = 'call-list-request';
              newtx.msg.call_id = this.room_obj.call_id;
              _context8.n = 3;
              return newtx.sign();
            case 3:
              console.info('TALK: Sending call entry: ', newtx.msg, event, this.room_obj, new Date(newtx.timestamp).toTimeString());
              this.have_joined_room = newtx.timestamp;
              this.app.connection.emit('relay-transaction', newtx);
              this.app.network.propagateTransaction(newtx);
              this.addCallParticipant(this.room_obj.call_id, this.publicKey);
            case 4:
              return _context8.a(2);
          }
        }, _callee8, this);
      }));
      function sendCallEntryTransaction() {
        return _sendCallEntryTransaction.apply(this, arguments);
      }
      return sendCallEntryTransaction;
    }()
  }, {
    key: "receiveCallListRequestTransaction",
    value: function () {
      var _receiveCallListRequestTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(app, tx) {
        var _this$room_obj3,
          _this5 = this;
        var txmsg, from, _this$diagnostics3, call_list, event, _this$room_obj4, c, processed;
        return _regenerator().w(function (_context9) {
          while (1) switch (_context9.n) {
            case 0:
              txmsg = tx.returnMessage();
              from = tx.from[0].publicKey; //Update calendar event
              this.addCallParticipant(txmsg.call_id, from);
              console.log('TALK [receiveCallListRequest]: ', from);

              //We are getting a tx for the call we are in
              if (!((this === null || this === void 0 || (_this$room_obj3 = this.room_obj) === null || _this$room_obj3 === void 0 ? void 0 : _this$room_obj3.call_id) === txmsg.call_id)) {
                _context9.n = 1;
                break;
              }
              (_this$diagnostics3 = this.diagnostics) === null || _this$diagnostics3 === void 0 || _this$diagnostics3.record(from, 'Received: call-list-request');
              call_list = [];
              if (this.room_obj.call_peers) {
                this.room_obj.call_peers.forEach(function (key) {
                  if (!call_list.includes(key)) {
                    call_list.push(key);
                  }
                });
              }
              if (!call_list.includes(this.publicKey)) {
                call_list.push(this.publicKey);
              }
              this.app.connection.emit('stun-update-link');
              if (!tx.isFrom(this.publicKey)) {
                setTimeout(function () {
                  console.log('Send response');
                  _this5.sendCallListResponseTransaction(from, call_list);
                }, 250 + Math.max(0, tx.timestamp - Date.now()));
              }
              return _context9.a(2);
            case 1:
              // Process if we saved event but are not in the call!
              event = this.app.keychain.returnKey(txmsg.call_id, true);
              if (!(event && !event.ended)) {
                _context9.n = 4;
                break;
              }
              console.info('TALK EVENT!!!', event);
              // I am in a different call
              if (!((_this$room_obj4 = this.room_obj) !== null && _this$room_obj4 !== void 0 && _this$room_obj4.call_id)) {
                _context9.n = 2;
                break;
              }
              siteMessage("".concat(this.app.keychain.returnUsername(from), " joined ").concat(event.identifier));
              _context9.n = 4;
              break;
            case 2:
              _context9.n = 3;
              return sconfirm("".concat(this.app.keychain.returnUsername(from), " ready for ").concat(event.identifier, ", join now?"));
            case 3:
              c = _context9.v;
              if (c) {
                if (event !== null && event !== void 0 && event.link) {
                  processed = false;
                  this.app.modules.getRespondTos('saito-link', {
                    link: event.link
                  }).forEach(function (modResponse) {
                    processed = true;
                    modResponse.processLink(event.link);
                  });
                  if (!processed) {
                    navigateWindow(event.link);
                  }
                } else {
                  salert('No saved link');
                }
              }
            case 4:
              return _context9.a(2);
          }
        }, _callee9, this);
      }));
      function receiveCallListRequestTransaction(_x1, _x10) {
        return _receiveCallListRequestTransaction.apply(this, arguments);
      }
      return receiveCallListRequestTransaction;
    }()
  }, {
    key: "sendCallListResponseTransaction",
    value: function () {
      var _sendCallListResponseTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee0(public_key, call_list) {
        var newtx;
        return _regenerator().w(function (_context0) {
          while (1) switch (_context0.n) {
            case 0:
              _context0.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(public_key);
            case 1:
              newtx = _context0.v;
              newtx.msg = {
                module: 'Videocall',
                request: 'call-list-response',
                call_list: call_list,
                public_key: public_key,
                call_id: this.room_obj.call_id
              };
              _context0.n = 2;
              return newtx.sign();
            case 2:
              console.debug('TALK: send callListResponse: to ' + public_key, call_list);
              this.app.connection.emit('relay-transaction', newtx);
              this.app.network.propagateTransaction(newtx);
            case 3:
              return _context0.a(2);
          }
        }, _callee0, this);
      }));
      function sendCallListResponseTransaction(_x11, _x12) {
        return _sendCallListResponseTransaction.apply(this, arguments);
      }
      return sendCallListResponseTransaction;
    }()
  }, {
    key: "receiveCallListResponseTransaction",
    value: function receiveCallListResponseTransaction(app, tx) {
      var _this$diagnostics4,
        _this6 = this;
      var txmsg = tx.returnMessage();
      if (txmsg.public_key !== this.publicKey) {
        console.warn("TALK received callListResponse for ".concat(txmsg.public_key));
      }
      (_this$diagnostics4 = this.diagnostics) === null || _this$diagnostics4 === void 0 || _this$diagnostics4.record(tx.from[0].publicKey, 'Received: call-list-response');
      var call_list = txmsg.call_list;
      // remove my own key
      call_list = call_list.filter(function (key) {
        return _this6.publicKey !== key;
      });

      //
      // Create a connection with everyone
      //
      console.debug('TALK [callListResponse]: My peer list: ', this.room_obj.call_peers, 'Received list: ', call_list);
      var _iterator4 = _createForOfIteratorHelper(call_list),
        _step4;
      try {
        var _loop2 = function _loop2() {
          var peer = _step4.value;
          // update keychain
          _this6.addCallParticipant(txmsg.call_id, peer);
          if (peer !== _this6.publicKey) {
            var _this6$room_obj, _this6$streams;
            if (!((_this6$room_obj = _this6.room_obj) !== null && _this6$room_obj !== void 0 && _this6$room_obj.call_peers.includes(peer))) {
              var _this6$room_obj2;
              (_this6$room_obj2 = _this6.room_obj) === null || _this6$room_obj2 === void 0 || _this6$room_obj2.call_peers.push(peer);
              console.debug('TALK [callListResponse]: add peer to room obj');
            }

            // A pre-existing Saito data channel still needs the call join message
            // and the media-attachment event supplied by createPeerConnection.
            var pc = _this6.stun.peers.get(peer);
            var localTracks = ((_this6$streams = _this6.streams) === null || _this6$streams === void 0 || (_this6$streams = _this6$streams.localStream) === null || _this6$streams === void 0 ? void 0 : _this6$streams.getTracks()) || [];
            var hasCallMedia = pc === null || pc === void 0 ? void 0 : pc.getSenders().some(function (sender) {
              return localTracks.includes(sender.track);
            });
            if (!_this6.stun.hasConnection(peer, true) || !hasCallMedia) {
              console.debug('TALK [callListResponse]: create connection with ', peer);
              _this6.stun.createPeerConnection(peer, function (peerId) {
                console.debug('TALK [callListResponse]: ready for STUN connection with ' + peerId);
                _this6.sendCallJoinTransaction(peerId);
              });
            } else {
              console.debug('TALK [callListResponse]: DONT create connection with ', peer);
            }
          }
        };
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          _loop2();
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      this.app.connection.emit('stun-update-link');
      this.app.storage.saveOptions();
    }

    //
    // Videocall and stun both need a join connection, but we need videocall to process first so that the
    // key is added to the white list and the stun connection can be treated as a call entry (as opposed to
    // someone else establising a stun connection for other purposes)
    //
  }, {
    key: "sendCallJoinTransaction",
    value: function () {
      var _sendCallJoinTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee1(publicKey) {
        var _this$diagnostics5;
        var newtx;
        return _regenerator().w(function (_context1) {
          while (1) switch (_context1.n) {
            case 0:
              (_this$diagnostics5 = this.diagnostics) === null || _this$diagnostics5 === void 0 || _this$diagnostics5.record(publicKey, 'Preparing call join message');
              _context1.n = 1;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(publicKey);
            case 1:
              newtx = _context1.v;
              newtx.msg = {
                module: 'Videocall',
                request: 'peer-joined',
                call_id: this.room_obj.call_id
              };
              _context1.n = 2;
              return newtx.sign();
            case 2:
              console.debug('TALK [sendCallJoinTransaction]: kicking of stun protocol');
              this.app.connection.emit('relay-transaction', newtx);
              this.app.network.propagateTransaction(newtx);
              this.app.connection.emit('add-remote-stream-request', publicKey, null);
            case 3:
              return _context1.a(2);
          }
        }, _callee1, this);
      }));
      function sendCallJoinTransaction(_x13) {
        return _sendCallJoinTransaction.apply(this, arguments);
      }
      return sendCallJoinTransaction;
    }()
  }, {
    key: "sendCallDisconnectTransaction",
    value: function () {
      var _sendCallDisconnectTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee10() {
        var newtx, _iterator5, _step5, peer, _iterator6, _step6, _peer;
        return _regenerator().w(function (_context10) {
          while (1) switch (_context10.n) {
            case 0:
              if (this !== null && this !== void 0 && this.room_obj) {
                _context10.n = 1;
                break;
              }
              console.error('TALK [callDisconnect]: No room object!');
              return _context10.a(2);
            case 1:
              console.info('TALK [callDisconnect] (hang up):', this.room_obj);
              _context10.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 2:
              newtx = _context10.v;
              _iterator5 = _createForOfIteratorHelper(this.room_obj.call_peers);
              try {
                for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
                  peer = _step5.value;
                  if (peer != this.publicKey) {
                    newtx.addTo(peer);
                  }
                }
              } catch (err) {
                _iterator5.e(err);
              } finally {
                _iterator5.f();
              }
              newtx.msg = {
                module: 'Stun',
                request: 'peer-left',
                call_id: this.room_obj.call_id
              };
              _context10.n = 3;
              return newtx.sign();
            case 3:
              this.app.connection.emit('relay-transaction', newtx);

              //
              // Allow us to use stun connection to send tx before disconnecting!
              //
              _iterator6 = _createForOfIteratorHelper(this.room_obj.call_peers);
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  _peer = _step6.value;
                  if (_peer != this.publicKey) {
                    //Disconnect stun on our end
                    // the send tx will tell (former) peers to do the same
                    this.stun.removePeerConnection(_peer);
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
            case 4:
              return _context10.a(2);
          }
        }, _callee10, this);
      }));
      function sendCallDisconnectTransaction() {
        return _sendCallDisconnectTransaction.apply(this, arguments);
      }
      return sendCallDisconnectTransaction;
    }()
  }, {
    key: "sendKickTransaction",
    value: function () {
      var _sendKickTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee11(peer) {
        var newtx;
        return _regenerator().w(function (_context11) {
          while (1) switch (_context11.n) {
            case 0:
              if (this !== null && this !== void 0 && this.room_obj) {
                _context11.n = 1;
                break;
              }
              console.error('TALK [sendKick]: No room object!');
              return _context11.a(2);
            case 1:
              console.debug('TALK: Send kick message:', this.room_obj, peer);
              _context11.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(peer);
            case 2:
              newtx = _context11.v;
              newtx.msg = {
                module: 'Stun',
                request: 'peer-kicked',
                call_id: this.room_obj.call_id
              };
              _context11.n = 3;
              return newtx.sign();
            case 3:
              this.app.connection.emit('relay-transaction', newtx);

              //
              // Allow us to use stun connection to send tx before disconnecting!
              //
              this.stun.removePeerConnection(peer);
              this.sendKickBroadcastMessageTransaction(peer);
            case 4:
              return _context11.a(2);
          }
        }, _callee11, this);
      }));
      function sendKickTransaction(_x14) {
        return _sendKickTransaction.apply(this, arguments);
      }
      return sendKickTransaction;
    }()
  }, {
    key: "sendKickBroadcastMessageTransaction",
    value: function () {
      var _sendKickBroadcastMessageTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee12(peer_id) {
        var newtx, _iterator7, _step7, peer;
        return _regenerator().w(function (_context12) {
          while (1) switch (_context12.n) {
            case 0:
              if (this !== null && this !== void 0 && this.room_obj) {
                _context12.n = 1;
                break;
              }
              console.error('TALK [sendKickBroadcast]: No room object!');
              return _context12.a(2);
            case 1:
              _context12.n = 2;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee();
            case 2:
              newtx = _context12.v;
              _iterator7 = _createForOfIteratorHelper(this.room_obj.call_peers);
              try {
                for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                  peer = _step7.value;
                  if (peer != this.publicKey && peer !== peer_id) {
                    newtx.addTo(peer);
                  }
                }
              } catch (err) {
                _iterator7.e(err);
              } finally {
                _iterator7.f();
              }
              newtx.msg = {
                module: 'Stun',
                request: 'peer-kick-broadcast',
                data: {
                  kicked_peer: peer_id
                },
                call_id: this.room_obj.call_id
              };
              console.debug('TALK [sendKickBroadcast]:', this.room_obj, newtx.msg);
              _context12.n = 3;
              return newtx.sign();
            case 3:
              this.app.connection.emit('relay-transaction', newtx);
            case 4:
              return _context12.a(2);
          }
        }, _callee12, this);
      }));
      function sendKickBroadcastMessageTransaction(_x15) {
        return _sendKickBroadcastMessageTransaction.apply(this, arguments);
      }
      return sendKickBroadcastMessageTransaction;
    }()
  }, {
    key: "receiveBroadcastListTransaction",
    value: function () {
      var _receiveBroadcastListTransaction = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee13(app, tx) {
        var _this7 = this;
        var txmsg, sender, call_list, peer;
        return _regenerator().w(function (_context13) {
          while (1) switch (_context13.n) {
            case 0:
              txmsg = tx.returnMessage();
              sender = tx.from[0].publicKey; // Need code here to process keys that aren't otherwise in our call list
              // retrigger stun connections
              call_list = [];
              for (peer in txmsg.data) {
                if (txmsg.data[peer] == 'connected') {
                  if (peer !== this.publicKey) {
                    if (!this.room_obj.call_peers.includes(peer)) {
                      this.room_obj.call_peers.push(peer);
                      console.warn('TALK [broadcastList]: post hoc peer list member, attempt connection with ', peer);
                      this.stun.createPeerConnection(peer, function (peerId) {
                        _this7.sendCallJoinTransaction(peerId);
                      });
                    }
                  }
                }
              }

              //Update display of videoboxes
              this.app.connection.emit('peer-list', sender, txmsg.data);
            case 1:
              return _context13.a(2);
          }
        }, _callee13, this);
      }));
      function receiveBroadcastListTransaction(_x16, _x17) {
        return _receiveBroadcastListTransaction.apply(this, arguments);
      }
      return receiveBroadcastListTransaction;
    }()
  }, {
    key: "addCallParticipant",
    value: function addCallParticipant(call_id, publicKey) {
      var event = this.app.keychain.returnKey(call_id, true);
      // We will add this key as a call participant...
      if (event) {
        var _event$profile2;
        if (!(event !== null && event !== void 0 && event.profile)) {
          event.profile = {};
        }
        if (!((_event$profile2 = event.profile) !== null && _event$profile2 !== void 0 && _event$profile2.participants)) {
          event.profile.participants = [];
        }
        if (!event.profile.participants.includes(publicKey)) {
          event.profile.participants.push(publicKey);
          this.app.keychain.saveKeys();
        }
      }
    }
  }, {
    key: "saveCallToKeychain",
    value: function saveCallToKeychain() {
      var _this$room_obj5, _this$room_obj6;
      var call_link = this.generateCallLink();
      var name = 'Video Call';
      if ((_this$room_obj5 = this.room_obj) !== null && _this$room_obj5 !== void 0 && _this$room_obj5.ui) {
        name = 'Private Call';
      }
      if ((_this$room_obj6 = this.room_obj) !== null && _this$room_obj6 !== void 0 && _this$room_obj6.host_public_key) {
        name += ' ' + this.app.keychain.returnUsername(this.room_obj.host_public_key);
      }
      if (!this.app.keychain.returnKey(this.room_obj.call_id), true) {
        this.app.keychain.addKey(this.room_obj.call_id, {
          identifier: name,
          type: 'event',
          mod: 'videocall',
          startTime: Date.now(),
          link: call_link
        });
      }
      console.debug('TALK: save call to keychain', this.room_obj);
      this.app.keychain.addWatchedPublicKey(this.room_obj.call_id);
    }
  }, {
    key: "createRoom",
    value: function createRoom() {
      var identifier = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'my video call';
      var call_id = this.generateRoomId();
      this.room_obj = {
        call_id: call_id,
        host_public_key: this.publicKey,
        call_peers: []
      };
      var link = this.generateCallLink(this.room_obj);
      this.app.keychain.addKey(call_id, {
        identifier: identifier,
        link: link
      });
      return link;
    }
  }, {
    key: "generateRoomId",
    value: function generateRoomId() {
      var pk = this.app.crypto.generateKeys();
      var id = this.app.crypto.generatePublicKey(pk);
      this.app.keychain.addKey(id, {
        identifier: id,
        privateKey: pk,
        type: 'event',
        mod: 'videocall',
        startTime: Date.now(),
        watched: true
      });
      return id;
    }
  }, {
    key: "generateCallLink",
    value: function generateCallLink() {
      var room_obj = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.room_obj;
      var base64obj = this.app.crypto.stringToBase64(JSON.stringify(room_obj));
      var call_link = window.location.origin + '/videocall/';
      call_link = "".concat(call_link, "?stun_video_chat=").concat(base64obj);
      return call_link;
    }
  }, {
    key: "copyInviteLink",
    value: function () {
      var _copyInviteLink = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee14() {
        var link;
        return _regenerator().w(function (_context14) {
          while (1) switch (_context14.n) {
            case 0:
              _context14.n = 1;
              return this.createShortLink(this.generateCallLink());
            case 1:
              link = _context14.v;
              _context14.n = 2;
              return navigator.clipboard.writeText(link);
            case 2:
              siteMessage('Invite link copied to clipboard', 1500);
            case 3:
              return _context14.a(2);
          }
        }, _callee14, this);
      }));
      function copyInviteLink() {
        return _copyInviteLink.apply(this, arguments);
      }
      return copyInviteLink;
    }()
  }, {
    key: "webServer",
    value: function webServer(app, expressapp, express) {
      var webdir = "".concat(__dirname, "/../../mods/").concat(this.dirname, "/web");
      var mod_self = this;
      expressapp.get('/' + encodeURI(this.returnSlug()), /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee15(req, res) {
          var reqBaseURL;
          return _regenerator().w(function (_context15) {
            while (1) switch (_context15.n) {
              case 0:
                reqBaseURL = req.protocol + '://' + req.headers.host + '/';
                mod_self.social.url = reqBaseURL + encodeURI(mod_self.returnSlug());
                if (res.finished) {
                  _context15.n = 1;
                  break;
                }
                res.setHeader('Content-type', 'text/html');
                res.charset = 'UTF-8';
                return _context15.a(2, res.send(HomePage(app, mod_self, app.build_number, mod_self.social)));
              case 1:
                return _context15.a(2);
            }
          }, _callee15);
        }));
        return function (_x18, _x19) {
          return _ref.apply(this, arguments);
        };
      }());
      expressapp.use('/' + encodeURI(this.returnSlug()), express["static"](webdir));
    }
  }]);
}(ModTemplate);
module.exports = Videocall;